import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export const useGetNotifications = () => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: ['notifications'],

    queryFn: async () => {
      const res = await apiClient.notifications.getNotifications();
      return res;
    },

    enabled: !!apiClient.slug
  });
};
